import { c as _c } from "react-compiler-runtime";
import { useCallback, useSyncExternalStore } from 'react';
const EDITING_SELECTOR = '[data-editing="true"]';

// A cell announces edit mode with `data-editing="true"`. Some consumers put it
// on the <td> itself, others on a wrapper they render inside it, so check both.
const getIsEditing = element => element != null && (element.getAttribute('data-editing') === 'true' || element.querySelector(EDITING_SELECTOR) != null);

/**
 * Tracks whether `anchorElement` is in edit mode.
 *
 * Entering edit mode may either remount the `<td>` (a consumer swapping the
 * host element for a styled one) or just toggle the attribute on the existing
 * node. The anchor hook only re-resolves on childList mutations, so it catches
 * the first case but not the second — hence the attribute observer here.
 */
export const useIsAnchorCellEditing = anchorElement => {
  const $ = _c(4);
  let t0;
  if ($[0] !== anchorElement) {
    t0 = onStoreChange => {
      if (!anchorElement) {
        return _temp;
      }
      const observer = new MutationObserver(onStoreChange);
      observer.observe(anchorElement, {
        attributes: true,
        attributeFilter: ["data-editing"],
        childList: true,
        subtree: true
      });
      return () => observer.disconnect();
    };
    $[0] = anchorElement;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const subscribe = t0;
  let t1;
  if ($[2] !== anchorElement) {
    t1 = () => getIsEditing(anchorElement);
    $[2] = anchorElement;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useSyncExternalStore(subscribe, t1);
};
function _temp() {}